// Norge
export default {
	tabs: ["Ta ut", "Historie"],
	History: {
		tabs: ["Gjennomgår", "Vellykket", "Avvis"]
	},
	Withdraw: {
		label: ["Kontonummer", "Ordrenummer", "Adresse", "Beløp", "Gebyr", "Opprettet den", "Status", "Begrunnelse"]
	},
	AccountAmount: "Kontobeløp",
	tips: "Du vil motta uttaket ditt innen en time",
	form: {
		label: ["Beløp å ta ut", "Transaksjonspassord"],
		ALL: "ALLE",
		Withdraw: "Sende"
	},
	WithdrawAccount: "Ta ut konto",
	noAccountsTips: "Vennligst legg til betalingsmetoder",
	tradingKind: [
		"Cashback",
		"Fradrag",
		"Påfylling",
		"Uttak pågår",
		"Opplåsing av uttak",
		"Uttak",
		"Oppgave",
		"Tilbakebetaling av hovedstol",
		"Tilbakebetaling av provisjon",
		"Tilbakebetaling av underordnet provisjon",
		"Innsjekking",
		"Behandlingsgebyr",
		"Innskudd",
		"Belønning",
		"Grunnlønn",
		"Kontantstøtte",
		"Registreringsbonus",
		"Vareutbytte",
		"Oppgavebonus",
		"Annet",
		"",
		"Arbeidsbonus",
		"Oppgraderingsbelønninger",
		"Subsidie",
		"Ventende verifisering",
		"Kampanje",
		"Poenginnløsning",
		"Innloggingsbelønninger",
		"Arbeidsbelønninger",
		"Kredittpoeng-transaksjon"
	]
};
